export function SET_CLIENT_CLIENT(state, client_client) {
  state.client_client = client_client;
}

export function SET_TYPE_SERVICES(state, type_services) {
  state.type_services = type_services;
}
